export default __webpack_public_path__ + "static/media/Jason-Zommick.2f626f32.png";